import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import StorageHandler from 'config/StorageHandler';

import { social, storageKeys } from 'settings';

const Icon = ({ href, icon, size = 'inherit' }) => (
  <a
    style={{ fontSize: !Number.isNaN(+size) ? `${size}rem` : size }}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="icons"
  >
    <FontAwesomeIcon icon={icon.replace('twitter', 'x-twitter').split(' ')} />
  </a>
);

const SocialIcons = ({ size = 'inherit', customIcons = {} }) => {
  const [socials, setSocials] = useState(null);
  const [filteredSocials, setFilteredSocials] = useState(null);

  const loadSocials = useCallback(async () => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      const {socials: newSocials} = appInfo;
      setSocials(newSocials);
    }
  }, [])

  const setSocialIcons = useCallback(() => {
    const filteredSocialObject = {};
    if (socials) {
      Object.keys(customIcons).forEach((icon) => {
        if (social[icon].length > 0) {
          filteredSocialObject[icon] = {
            icon: customIcons[icon],
            href: social[icon],
          };
        }
      });

      Object.keys(socials).forEach((name) => {
        if (socials[name] && socials[name].length > 0 && filteredSocialObject[name] === undefined) {
          filteredSocialObject[`fab ${name}`] = socials[name];
        }
      });

      setFilteredSocials(filteredSocialObject);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socials]) // Cannot find out a reason why adding the customIcons prop to dependancies causes problems with infinite renders, but excluding it doesn't seem to matter.

  useEffect(() => {
    loadSocials();
  }, [loadSocials])

  useEffect(() => {
    setSocialIcons();
  }, [setSocialIcons]);

  let icons;
  if (filteredSocials) {
    icons = Object.keys(filteredSocials).map((name) => (
      <Icon
        key={name}
        href={filteredSocials[name].href || filteredSocials[name]}
        icon={filteredSocials[name].icon || name}
        size={size}
      />
    ));
  }

  return <div className="socialIcons">{icons}</div>;
};

export default SocialIcons;

SocialIcons.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  customIcons: PropTypes.shape(),
};

Icon.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
